import { statusBadgeClass } from "@/lib/listFormat";
import { invoiceStatusLabel, type InvoiceStatus } from "@/lib/invoices";

// BRK-S187 — an invoice's broker-safe status, one chip for the tab and the
// detail. Overdue is amber (something is owed), never the error colour: an
// overdue invoice is the contractor's, not a failure of the portal.
const CLASS: Record<InvoiceStatus, string> = {
  due: statusBadgeClass("submitted"),
  paid: statusBadgeClass("approved"),
  overdue: statusBadgeClass("referred"),
  awaiting_decision: statusBadgeClass("referred"),
};

export function InvoiceStatusChip({
  status,
}: {
  status: InvoiceStatus | null;
}) {
  return (
    <span
      data-testid="invoice-status"
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
        status === null ? statusBadgeClass("draft") : CLASS[status]
      }`}
    >
      {invoiceStatusLabel(status)}
    </span>
  );
}
